import { IncomingContent } from '@/data/types/IncomingContent';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

type PageContextType = {
	rawData?: IncomingContent;
};

export const PageContext = createContext<PageContextType>({} as PageContextType);

export const usePageContext = () => {
	const context = useContext(PageContext);

	if (!context) {
		throw new Error('usePageContext must be used within a PageProvider');
	}
	return context;
};

export const PageProvider: FC<PropsWithChildren<PageContextType>> = ({ rawData, children }) => (
	<PageContext.Provider value={{ rawData }}>{children}</PageContext.Provider>
);
